// import TextWrap from "../custom/TextWrap.js";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { HiMiniXMark } from "react-icons/hi2";
import { IoMdCheckmark } from "react-icons/io";
import DropdownMenubar from "../components/Menubar/DropdownMenubar";
import TextWrapper from "../custom/TextWrapper";

const DD = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const getVendorInfo = (row, handleCellClick) => {
  return DD([
    {
      label: "APPROVE",
      icon: (
        <div className="  text-white  rounded-full bg-green600">
          {" "}
          <IoMdCheckmark className="" />
        </div>
      ),

      command: () => {
        handleCellClick(row, "Approved");
      },
    },
    {
      label: "UNAPPROVE",
      icon: (
        <div className="  text-white  rounded-full bg-red600">
          {" "}
          <HiMiniXMark className="" />
        </div>
      ),
      command: () => {
        handleCellClick(row, "Rejected");
      },
    },
  ]);
};
export const columns = [
  {
    field: "receiptNumber",
    header: "Receipt Number",
    accessor: (row, handleCellClick) => (
      <div
        className="text-green700 font-semibold cursor-pointer hover:underline"
        onClick={() => handleCellClick(row, "receiptNumber")}
        title="Click to view details"
      >
        {row?.receiptNumber || <span className="text-gray500">N/A</span>}
      </div>
    ),
  },
  {
    field: "dateOfReceipt",
    header: "Date of Receipt",
    accessor: (row) => (
      <div className="text-sm text-gray600 font-medium">
        {row.dateOfReceipt ? (
          <span className="inline-flex items-center px-3 py-1 bg-gren100 text-green800 text-xs font-semibold rounded-full">
            {new Date(row.dateOfReceipt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        ) : (
          <span className="text-gray500">N/A</span>
        )}
      </div>
    ),
  },
  {
    field: "receivedFrom",
    header: "Received From",
    accessor: (row) => (
      <div className="text-sm font-medium text-gray700 truncate max-w-[150px]">
        {row?.receivedFrom || <span className="text-gray500">N/A</span>}
      </div>
    ),
  },
  {
    field: "orderReference",
    header: "Order Reference",
    accessor: (row) => (
      <div className="text-sm font-medium text-gray700 truncate max-w-[150px]">
        {row?.orderReference || <span className="text-gray500">N/A</span>}
      </div>
    ),
  },
  {
    field: "vendorLocation",
    header: "Vendor Location",
    accessor: (row) => (
      <div className="text-sm text-gray700 truncate max-w-[150px]">
        <i className="fas fa-map-marker-alt text-red500 mr-1"></i>
        {row?.vendorLocation || <span className="text-gray500">N/A</span>}
      </div>
    ),
  },
  {
    field: "attachments",
    header: "Attachments",
    accessor: (row) => (
      <div className="w-24 h-24 overflow-hidden rounded-md border border-gray200 shadow-sm flex items-center justify-center">
        {row?.attachments?.[0] ? (
          <LazyLoadImage
            src={row.attachments}
            alt="Attachment"
            loading="lazy"
            effect="blur"
            wrapperProps={{
              style: { transitionDelay: "1s" },
            }}
            className=""
          />
        ) : (
          <span className="text-gray500 text-xs">No Image</span>
        )}
      </div>
    ),
  },
  {
    field: "itemDetails",
    header: "Item Details",
    accessor: (row, handleCellClick) => (
      <div
        className="space-y-4 text-green700"
        onClick={() => handleCellClick(row, "viewDetails")}
      >
        View
      </div>
    ),
  },
  {
    field: "createdAt",
    header: "Created At",
    accessor: (row) => (
      <div className="text-sm text-gray600 font-medium">
        {row.createdAt ? (
          <span className="inline-flex items-center px-3 py-1 bg-gren100 text-green800 text-xs font-semibold rounded-full">
            {new Date(row.createdAt).toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        ) : (
          <span className="text-gray500">N/A</span>
        )}
      </div>
    ),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  // enum: ['Store', 'Product', 'Category', 'Sub Category'],
  {
    filterType: "Filter by A/U",
    inputName: "status",
    options: [
      {
        name: "Approved",
        code: "Approved",
      },
      {
        name: "Rejected",
        code: "Rejected",
      },
    ],
  },
];
